var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickInARollIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 4.29427V6.00844C15.5835 7.1276 14.8752 7.83594 13.756 7.83594H11.3335V2.88469C11.3335 2.09844 11.9781 1.46094 12.7643 1.46094C13.5364 1.46802 14.2447 1.77969 14.7547 2.28969C15.2647 2.80677 15.5835 3.5151 15.5835 4.29427Z",
    stroke: "#3876BB",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 4.90237V14.5384C1.4165 15.1097 2.08234 15.4332 2.54984 15.089L3.76109 14.208C4.04442 14.0015 4.44109 14.0291 4.69609 14.2768L5.87192 15.4263C6.14817 15.6947 6.60151 15.6947 6.87776 15.4263L8.06775 14.27C8.31567 14.0291 8.71234 14.0015 8.98859 14.208L10.1998 15.089C10.6673 15.4263 11.3332 15.1028 11.3332 14.5384V2.83751C11.3332 2.0804 11.9707 1.46094 12.7498 1.46094H4.95817H4.24984C2.12484 1.46094 1.4165 2.69297 1.4165 4.21409V4.90237Z",
    stroke: "#3876BB",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42725 7.125H8.32308",
    stroke: "#3876BB",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 9.07552V5.17969",
    stroke: "#3876BB",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickInARollIcon);
export default __webpack_public_path__ + "static/media/TickInARollIcon.c6e20165415b6d4255d298cd04513cc5.svg";
export { ForwardRef as ReactComponent };